export enum ResultType {
  SEARCH_RESULTS = 'searchResults',
  SUGGESTED_RESULTS = 'suggestedSearchResults'
}
